// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__50dfT","image":"styles_image__1GNqg","sector":"styles_sector__yEnc4","content":"styles_content__81MdA","more":"styles_more__Vkmtl"};